export default function (masterSnowFall, selectedState) {
  const stateLocations = masterSnowFall.data.features
    .filter((d) => d.properties.state === selectedState);
  const stateTowns = stateLocations.map((d) => d.properties.town.trim());
  const uniqueTowns = [...new Set(stateTowns)];
  uniqueTowns.sort();
  return uniqueTowns;
}
